import { useContext } from 'react';
import {
  FilteredOperationsContext,
  FilteredOperationsContextValue,
} from '../context/FilteredOperationsProvider';

/**
 * Hook to access the OpenAPI filtered operations context
 * Must be used within a FilteredOperationsProvider
 */
export function useOpenAPIFilteredOperations(): FilteredOperationsContextValue {
  const context = useContext(FilteredOperationsContext);

  if (!context) {
    throw new Error(
      'useOpenAPIFilteredOperations must be used within a FilteredOperationsProvider',
    );
  }

  return context;
}

export default useOpenAPIFilteredOperations;
